import { useSyncExternalStore } from "react";

const queries = new Map<string, MediaQueryList>();
const media = (query: string) => {
  let held = queries.get(query);
  if (!held) {
    held = window.matchMedia(query);
    queries.set(query, held);
  }
  return held;
};

/** Whether `query` matches, live. */
export function useMedia(query: string): boolean {
  return useSyncExternalStore(
    (listener) => {
      const list = media(query);
      list.addEventListener("change", listener);
      return () => list.removeEventListener("change", listener);
    },
    () => media(query).matches,
  );
}

/** The desk layout, from 1024px. */
export const useDesk = () => useMedia("(min-width: 1024px)");
